import React, { useMemo } from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import { JsonForms } from '@jsonforms/react'
import { materialCells } from '@jsonforms/material-renderers'
import DropWrapper from 'designer/component/system/layout/control/DropWrapper'

import { createSystemRenderer } from 'designer/component/control/renderer'

export const ModalFooter = (props) => {
  let { data, schema, uischema } = props
  const renderers = useMemo(
    () => createSystemRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)]
  )

  return (
    <DropWrapper {...props}>
      <p
        className="position-absolute d-flex align-items-end m-0"
        style={{ top: '5px' }}
      >
        ออกแบบ Modal Footer
      </p>
      <JsonForms
        schema={schema}
        uischema={uischema}
        data={data}
        renderers={renderers}
        cells={materialCells}
      />
    </DropWrapper>
  )
}

export const modalFooterTester = rankWith(3, scopeEndsWith('modalFooter'))

export const modalFooter = {
  tester: modalFooterTester,
  renderer: withJsonFormsControlProps(ModalFooter),
}
